import Vue from 'vue'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './common/element-variables.scss'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'

Vue.prototype.$api = api

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
